module.exports = __webpack_public_path__ + "static/img/H1.7aabd08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mjhl2/H1.png
// module id = JK8a
// module chunks = 0